export interface ChatState {
  isChatBoxMinimized: boolean;
  showChatBox: boolean;
  messages: any[];
}

export const initialChatState: ChatState = {
  isChatBoxMinimized: false,
  showChatBox: true,
  messages: []
}; 